/**
 * Nuxt `@nuxt/pages` scrollBehavior для смены только `hash` берёт
 * `router.options.scrollBehaviorType ?? 'auto'` (см. `node_modules/nuxt/dist/pages/runtime/router.options.js`).
 * Со значением `'smooth'` переход по якорю и `router.replace({ hash })` не делают мгновенный скачок.
 */
export default defineNuxtPlugin(() => {
  const router = useRouter();
  const opts = router.options as { scrollBehaviorType?: string };
  opts.scrollBehaviorType = 'smooth';
});
